<template lang="pug">
  lazy-load(
    v-model="modules.loadMore"
    @on-response="({ items }) => modules.items.push(...items)"
  )
    v-slide-y-reverse-transition(group tag="div" class="row" leave-absolute)
      template(v-if="modules.loading")
        v-col(cols=12 md=4)(
          v-for="n in 6" :key="`sl${n}`"
        )
          v-skeleton-loader(
            class="mx-auto"
            type="article, actions"
          )
      template(v-else)
        v-col(cols=12 md=4)(
          v-for="moduleItem in modules.items"
          :key="moduleItem.id"
        )
          v-card(
            @click="openModulePreview(moduleItem)"
          ).sdo-card.stock-item.fill-height
            v-card-text.pa-7.pb-3
              div: strong {{ moduleItem.name }}
              p.grey--text {{ $tc('units', moduleItem.course_units_count) }}
              .stock-item--description.caption {{ moduleItem.description }}

              v-list.ma-0
                template(v-if="moduleItem.type !== $conf.COURSE_TYPES.qualification")
                  v-list-item.px-0(v-if="moduleItem.direction")
                    v-list-item-avatar
                      v-icon ${{ getIcon(moduleItem.direction) }}
                    v-list-item-content()
                      v-list-item-title Направленность
                      v-list-item-subtitle {{directions[moduleItem.direction].name}}
                  v-list-item.px-0
                    v-list-item-avatar
                      v-icon mdi-account-child-outline
                    v-list-item-content
                      v-list-item-title Возраст
                      v-list-item-subtitle {{ moduleItem.ageDistanceString }}
                template(v-else)
                  v-list-item.px-0
                    v-list-item-avatar
                      v-icon(size=30 color="warning darken-1") mdi-account-arrow-up
                    v-list-item-content
                      v-list-item-subtitle Модуль повышения квалификации

                  v-list-item.px-0
                    v-list-item-avatar
                      v-icon mdi-information-outline
                    v-list-item-content Модуль предназначен для обучения сотрудников организаций

            v-sheet(color="secondary" dark).pa-7
              .d-flex.title
                span Цена за ученика
                v-spacer
                span {{ moduleItem.price_per_user }} ₽
              .d-flex.grey--text
                template(v-if="moduleItem.is_escorted")
                  span Цена с учетом сопровождения
                  v-spacer
                  span {{ moduleItem.price_escort_per_user }} ₽
                template(v-else)
                  span Сопровождение недоступно
                  v-spacer
                  v-icon(small) mdi-lock-outline
</template>

<script>
import ModulePreview from '../components/ModulePreview.vue';

export default {
  props: {
    searchQ: { type: Object, default: null },
    searchType: { type: [String, Number], default: null },
    directionsItems: { type: Array, default: () => [] },
  },
  data() {
    return {
      modules: {
        items: null,
        loadMore: null,
        loading: false,
      },
    };
  },
  computed: {
    directions() {
      return this.directionsItems.reduce((acc, cur) => {
        acc[cur.id] = cur;
        return acc;
      }, {});
    },
  },
  watch: {
    searchQ: {
      handler() {
        this.fetchModules();
      },
      deep: true,
    },
  },

  created() {
    this.fetchModules();
  },
  methods: {
    getIcon(directionId) {
      let icon;
      switch (directionId) {
        case 1: icon = 'robo'; break;
        case 2: icon = 'tech'; break;
        case 3: icon = 'art'; break;
        case 4: icon = 'science'; break;
        case 5: icon = 'social'; break;
        case 6: icon = 'tourism'; break;
        case 7: icon = 'sport'; break;
        default: icon = 'art'; break;
      }
      return icon;
    },
    async fetchModules() {
      this.modules.loading = true;
      const searchParams = Object.entries(this.searchQ).reduce((acc, [key, value]) => ({ ...acc, [`search[${key}]`]: value }), {});
      const { items, loadMore } = await this.$api.modules.index({
        ...searchParams,
        'search[status]': this.$conf.MODULE_STATUSES.active,
        'search[type]': this.searchType,
        'per-page': 12,
        expand: 'course_units_count,accepted_users_count,user_status',
      });
      this.modules.items = items;
      this.modules.loadMore = loadMore;
      this.modules.loading = false;
    },
    openModulePreview(moduleItem) {
      this.$modals.show('generic-controller', {
        title: moduleItem.name,
        dialogProps: {
          width: 800,
        },
        component: ModulePreview,
        'component-props': {
          moduleItem,
          subscribed: !!moduleItem.user_status,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.stock-item {

  &--description {
    height: 40px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

}
</style>
